import MemberCenter from '@/views/mobile/MemberCenter/index'

// 定义路由路径数列表
export default [{
  path: '/memberCenter',
  name: '会员中心',
  component: MemberCenter
}]



// WEBPACK FOOTER //
// ./src/views/mobile/MemberCenter/routers/index.js